import { motion } from 'framer-motion/dist/framer-motion';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import styled from 'styled-components';

import { flexGap } from 'untils/polyfill/flex';

export const LocationContainer = styled(motion.div)`
  flex: 4 0.4 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${vw(8)};
  background-color: #fff;
  ${flexGap('16px')}
  @media (max-width: 938px) {
    padding: 16px;
    flex-direction: column;
  }
  @media (max-width: 757px) {
    ${flexGap('0')}
    padding:  8px 16px;
  }
`;

export const InputIcon = styled(motion.i)`
  width: 40px;
  height: 40px;
  background: ${(props) => props.$src && `center / cover no-repeat url(${props.$src})`};
  @media (max-width: 757px) {
    width: 24px;
    height: 24px;
  }
`;
